import template from './spending.html';
import controller from './spending.controller';

let spendingComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default spendingComponent;
